import { render, staticRenderFns } from "./ResultsByClubCard.vue?vue&type=template&id=7a7adffb&"
import script from "./ResultsByClubCard.vue?vue&type=script&lang=js&"
export * from "./ResultsByClubCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports